@if (dataLoading$ | async) {
  <div class="main row">Loading..</div>
} @else {
  <div class="main row" data-cy="sitemap">
    <div class="column twelve">
      <ds-shared-sitemap [linkListObj]="linkList"></ds-shared-sitemap>
    </div>
  </div>
}
